import { DELETE_KMZ } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const DeleteKmz = async (name, network) => {
  try {
    const resp = await apiClient.delete(DELETE_KMZ(name, network), {});
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
